import React from 'react';
import { toast, ToastContentProps } from 'react-toastify';
import { ErrorToast, SuccessToast } from '@hz-design-system/web-ui';
import 'react-toastify/dist/ReactToastify.css';

import Classes from './ToastNotification.scss';

toast.configure({
  className: Classes.message,
  bodyClassName: Classes.body,
  closeButton: false,
  draggable: false,
  newestOnTop: true,
  autoClose: 5000,
  progressClassName: Classes.progressBar,
  position: toast.POSITION.BOTTOM_CENTER,
  toastClassName: Classes.toast,
});

type TToastNotificationProps = {
  type: 'success' | 'error';
  description: string;
  delay?: number;
};

const ToastNotification = ({ type = 'success', description = '', delay = 0 }: TToastNotificationProps) => {
  if (type === 'success') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <SuccessToast icon="checkmark-circle" onClose={closeToast}>
          {description}
        </SuccessToast>
      ),
      {
        delay: delay,
      },
    );
  }

  if (type === 'error') {
    toast(
      ({ closeToast }: ToastContentProps) => (
        <ErrorToast icon="alert" onClose={closeToast}>
          {description}
        </ErrorToast>
      ),
      {
        delay: delay,
      },
    );
  }
};

export default ToastNotification;

export const dismissToast = toast.dismiss;
